// Data Explorer specific actions. No need to keep this in sync with the one in Portal.
// Some of the enums names are used in Fabric. Please do not rename them.
export var Action;
(function (Action) {
    Action[Action["CollapseTreeNode"] = 0] = "CollapseTreeNode";
    Action[Action["MetricsScenario"] = 1] = "MetricsScenario";
    Action[Action["CreateCollection"] = 2] = "CreateCollection";
    Action[Action["CreateGlobalSecondaryIndex"] = 3] = "CreateGlobalSecondaryIndex";
    Action[Action["CreateDocument"] = 4] = "CreateDocument";
    Action[Action["CreateStoredProcedure"] = 5] = "CreateStoredProcedure";
    Action[Action["CreateTrigger"] = 6] = "CreateTrigger";
    Action[Action["CreateUDF"] = 7] = "CreateUDF";
    Action[Action["DeleteCollection"] = 8] = "DeleteCollection";
    Action[Action["DeleteDatabase"] = 9] = "DeleteDatabase";
    Action[Action["DeleteDocument"] = 10] = "DeleteDocument";
    Action[Action["ExpandTreeNode"] = 11] = "ExpandTreeNode";
    Action[Action["ExecuteQuery"] = 12] = "ExecuteQuery";
    Action[Action["HasFeature"] = 13] = "HasFeature";
    Action[Action["GetVNETServices"] = 14] = "GetVNETServices";
    Action[Action["InitializeAccountLocationFromResourceGroup"] = 15] = "InitializeAccountLocationFromResourceGroup";
    Action[Action["InitializeDataExplorer"] = 16] = "InitializeDataExplorer";
    Action[Action["LoadDatabaseAccount"] = 17] = "LoadDatabaseAccount";
    Action[Action["LoadCollections"] = 18] = "LoadCollections";
    Action[Action["LoadDatabases"] = 19] = "LoadDatabases";
    Action[Action["LoadOffers"] = 20] = "LoadOffers";
    Action[Action["MongoShell"] = 21] = "MongoShell";
    Action[Action["ContextualPane"] = 22] = "ContextualPane";
    Action[Action["ScaleThroughput"] = 23] = "ScaleThroughput";
    Action[Action["ToggleAutoscaleSetting"] = 24] = "ToggleAutoscaleSetting";
    Action[Action["SelectItem"] = 25] = "SelectItem";
    Action[Action["Tab"] = 26] = "Tab";
    Action[Action["UpdateDocument"] = 27] = "UpdateDocument";
    Action[Action["UpdateSettings"] = 28] = "UpdateSettings";
    Action[Action["UpdateStoredProcedure"] = 29] = "UpdateStoredProcedure";
    Action[Action["UpdateTrigger"] = 30] = "UpdateTrigger";
    Action[Action["UpdateUDF"] = 31] = "UpdateUDF";
    Action[Action["LoadResourceTree"] = 32] = "LoadResourceTree";
    Action[Action["CreateDatabase"] = 33] = "CreateDatabase";
    Action[Action["ResolveConflict"] = 34] = "ResolveConflict";
    Action[Action["DeleteConflict"] = 35] = "DeleteConflict";
    Action[Action["SaveQuery"] = 36] = "SaveQuery";
    Action[Action["SetupSavedQueries"] = 37] = "SetupSavedQueries";
    Action[Action["LoadSavedQuery"] = 38] = "LoadSavedQuery";
    Action[Action["DeleteSavedQuery"] = 39] = "DeleteSavedQuery";
    Action[Action["ConnectEncryptionToken"] = 40] = "ConnectEncryptionToken";
    Action[Action["SignInAad"] = 41] = "SignInAad";
    Action[Action["SignOutAad"] = 42] = "SignOutAad";
    Action[Action["FetchTenants"] = 43] = "FetchTenants";
    Action[Action["FetchSubscriptions"] = 44] = "FetchSubscriptions";
    Action[Action["FetchAccounts"] = 45] = "FetchAccounts";
    Action[Action["GetAccountKeys"] = 46] = "GetAccountKeys";
    Action[Action["LoadingStatus"] = 47] = "LoadingStatus";
    Action[Action["AccountSwitch"] = 48] = "AccountSwitch";
    Action[Action["SubscriptionSwitch"] = 49] = "SubscriptionSwitch";
    Action[Action["TenantSwitch"] = 50] = "TenantSwitch";
    Action[Action["DefaultTenantSwitch"] = 51] = "DefaultTenantSwitch";
    Action[Action["CreateNotebookWorkspace"] = 52] = "CreateNotebookWorkspace";
    Action[Action["NotebookErrorNotification"] = 53] = "NotebookErrorNotification";
    Action[Action["CreateSparkCluster"] = 54] = "CreateSparkCluster";
    Action[Action["UpdateSparkCluster"] = 55] = "UpdateSparkCluster";
    Action[Action["DeleteSparkCluster"] = 56] = "DeleteSparkCluster";
    Action[Action["LibraryManage"] = 57] = "LibraryManage";
    Action[Action["ClusterLibraryManage"] = 58] = "ClusterLibraryManage";
    Action[Action["ModifyOptionForThroughputWithSharedDatabase"] = 59] = "ModifyOptionForThroughputWithSharedDatabase";
    Action[Action["EnableAzureSynapseLink"] = 60] = "EnableAzureSynapseLink";
    Action[Action["CreateNewNotebook"] = 61] = "CreateNewNotebook";
    Action[Action["OpenSampleNotebook"] = 62] = "OpenSampleNotebook";
    Action[Action["ExecuteCell"] = 63] = "ExecuteCell";
    Action[Action["ExecuteCellPromptBtn"] = 64] = "ExecuteCellPromptBtn";
    Action[Action["ExecuteAllCells"] = 65] = "ExecuteAllCells";
    Action[Action["NotebookEnabled"] = 66] = "NotebookEnabled";
    Action[Action["NotebooksGitHubConnect"] = 67] = "NotebooksGitHubConnect";
    Action[Action["NotebooksGitHubAuthorize"] = 68] = "NotebooksGitHubAuthorize";
    Action[Action["NotebooksGitHubManualRepoAdd"] = 69] = "NotebooksGitHubManualRepoAdd";
    Action[Action["NotebooksGitHubManageRepo"] = 70] = "NotebooksGitHubManageRepo";
    Action[Action["NotebooksGitHubCommit"] = 71] = "NotebooksGitHubCommit";
    Action[Action["NotebooksGitHubDisconnect"] = 72] = "NotebooksGitHubDisconnect";
    Action[Action["NotebooksFetched"] = 73] = "NotebooksFetched";
    Action[Action["NotebooksKernelSpecName"] = 74] = "NotebooksKernelSpecName";
    Action[Action["NotebooksExecuteCellFromMenu"] = 75] = "NotebooksExecuteCellFromMenu";
    Action[Action["NotebooksClearOutputsFromMenu"] = 76] = "NotebooksClearOutputsFromMenu";
    Action[Action["NotebooksInsertCodeCellAboveFromMenu"] = 77] = "NotebooksInsertCodeCellAboveFromMenu";
    Action[Action["NotebooksInsertCodeCellBelowFromMenu"] = 78] = "NotebooksInsertCodeCellBelowFromMenu";
    Action[Action["NotebooksInsertTextCellAboveFromMenu"] = 79] = "NotebooksInsertTextCellAboveFromMenu";
    Action[Action["NotebooksInsertTextCellBelowFromMenu"] = 80] = "NotebooksInsertTextCellBelowFromMenu";
    Action[Action["NotebooksMoveCellUpFromMenu"] = 81] = "NotebooksMoveCellUpFromMenu";
    Action[Action["NotebooksMoveCellDownFromMenu"] = 82] = "NotebooksMoveCellDownFromMenu";
    Action[Action["PhoenixConnection"] = 83] = "PhoenixConnection";
    Action[Action["PhoenixHeartBeat"] = 84] = "PhoenixHeartBeat";
    Action[Action["PhoenixResetWorkspace"] = 85] = "PhoenixResetWorkspace";
    Action[Action["PhoenixDBAccountAllowed"] = 86] = "PhoenixDBAccountAllowed";
    Action[Action["DeleteCellFromMenu"] = 87] = "DeleteCellFromMenu";
    Action[Action["OpenTerminal"] = 88] = "OpenTerminal";
    Action[Action["OpenCloudShellTerminal"] = 89] = "OpenCloudShellTerminal";
    Action[Action["CreateMongoCollectionWithWildcardIndex"] = 90] = "CreateMongoCollectionWithWildcardIndex";
    Action[Action["ClickCommandBarButton"] = 91] = "ClickCommandBarButton";
    Action[Action["RefreshResourceTreeMyNotebooks"] = 92] = "RefreshResourceTreeMyNotebooks";
    Action[Action["ClickResourceTreeNodeContextMenuItem"] = 93] = "ClickResourceTreeNodeContextMenuItem";
    Action[Action["DiscardSettings"] = 94] = "DiscardSettings";
    Action[Action["SettingsV2Updated"] = 95] = "SettingsV2Updated";
    Action[Action["SettingsV2Discarded"] = 96] = "SettingsV2Discarded";
    Action[Action["MongoIndexUpdated"] = 97] = "MongoIndexUpdated";
    Action[Action["NotebooksGalleryPublish"] = 98] = "NotebooksGalleryPublish";
    Action[Action["NotebooksGalleryReportAbuse"] = 99] = "NotebooksGalleryReportAbuse";
    Action[Action["NotebooksGalleryClickReportAbuse"] = 100] = "NotebooksGalleryClickReportAbuse";
    Action[Action["NotebooksGalleryViewCodeOfConduct"] = 101] = "NotebooksGalleryViewCodeOfConduct";
    Action[Action["NotebooksGalleryAcceptCodeOfConduct"] = 102] = "NotebooksGalleryAcceptCodeOfConduct";
    Action[Action["NotebooksGalleryFavorite"] = 103] = "NotebooksGalleryFavorite";
    Action[Action["NotebooksGalleryUnfavorite"] = 104] = "NotebooksGalleryUnfavorite";
    Action[Action["NotebooksGalleryClickDelete"] = 105] = "NotebooksGalleryClickDelete";
    Action[Action["NotebooksGalleryDelete"] = 106] = "NotebooksGalleryDelete";
    Action[Action["NotebooksGalleryClickDownload"] = 107] = "NotebooksGalleryClickDownload";
    Action[Action["NotebooksGalleryDownload"] = 108] = "NotebooksGalleryDownload";
    Action[Action["NotebooksGalleryViewNotebook"] = 109] = "NotebooksGalleryViewNotebook";
    Action[Action["NotebooksGalleryViewGallery"] = 110] = "NotebooksGalleryViewGallery";
    Action[Action["NotebooksGalleryViewOfficialSamples"] = 111] = "NotebooksGalleryViewOfficialSamples";
    Action[Action["NotebooksGalleryViewPublicGallery"] = 112] = "NotebooksGalleryViewPublicGallery";
    Action[Action["NotebooksGalleryViewFavorites"] = 113] = "NotebooksGalleryViewFavorites";
    Action[Action["NotebooksGalleryViewPublishedNotebooks"] = 114] = "NotebooksGalleryViewPublishedNotebooks";
    Action[Action["NotebooksGalleryClickPublishToGallery"] = 115] = "NotebooksGalleryClickPublishToGallery";
    Action[Action["NotebooksGalleryOfficialSamplesCount"] = 116] = "NotebooksGalleryOfficialSamplesCount";
    Action[Action["NotebooksGalleryPublicGalleryCount"] = 117] = "NotebooksGalleryPublicGalleryCount";
    Action[Action["NotebooksGalleryFavoritesCount"] = 118] = "NotebooksGalleryFavoritesCount";
    Action[Action["NotebooksGalleryPublishedCount"] = 119] = "NotebooksGalleryPublishedCount";
    Action[Action["SelfServe"] = 120] = "SelfServe";
    Action[Action["ExpandAddCollectionPaneAdvancedSection"] = 121] = "ExpandAddCollectionPaneAdvancedSection";
    Action[Action["ExpandAddGlobalSecondaryIndexPaneAdvancedSection"] = 122] = "ExpandAddGlobalSecondaryIndexPaneAdvancedSection";
    Action[Action["SchemaAnalyzerClickAnalyze"] = 123] = "SchemaAnalyzerClickAnalyze";
    Action[Action["SelfServeComponent"] = 124] = "SelfServeComponent";
    Action[Action["LaunchQuickstart"] = 125] = "LaunchQuickstart";
    Action[Action["NewContainerHomepage"] = 126] = "NewContainerHomepage";
    Action[Action["Top3ItemsClicked"] = 127] = "Top3ItemsClicked";
    Action[Action["LearningResourcesClicked"] = 128] = "LearningResourcesClicked";
    Action[Action["PlayCarouselVideo"] = 129] = "PlayCarouselVideo";
    Action[Action["OpenCarousel"] = 130] = "OpenCarousel";
    Action[Action["CompleteCarousel"] = 131] = "CompleteCarousel";
    Action[Action["LaunchUITour"] = 132] = "LaunchUITour";
    Action[Action["CancelUITour"] = 133] = "CancelUITour";
    Action[Action["CompleteUITour"] = 134] = "CompleteUITour";
    Action[Action["QueryEdited"] = 135] = "QueryEdited";
    Action[Action["DeleteDocuments"] = 136] = "DeleteDocuments";
    Action[Action["ReadPersistedTabState"] = 137] = "ReadPersistedTabState";
    Action[Action["SavePersistedTabState"] = 138] = "SavePersistedTabState";
    Action[Action["DeletePersistedTabState"] = 139] = "DeletePersistedTabState";
    Action[Action["UploadDocuments"] = 140] = "UploadDocuments";
    Action[Action["CloudShellUserConsent"] = 141] = "CloudShellUserConsent";
    Action[Action["CloudShellTerminalSession"] = 142] = "CloudShellTerminalSession";
    Action[Action["OpenVSCode"] = 143] = "OpenVSCode";
    Action[Action["ImportSampleData"] = 144] = "ImportSampleData";
    // Tracing for ApplicationLoad & DatabaseLoad scenarios
    Action[Action["ConfigurePortal"] = 145] = "ConfigurePortal";
    Action[Action["FetchAccountKeys"] = 146] = "FetchAccountKeys";
    Action[Action["AcquireMsalToken"] = 147] = "AcquireMsalToken";
    Action[Action["ReadDatabases"] = 148] = "ReadDatabases";
    Action[Action["ReadCollections"] = 149] = "ReadCollections";
    Action[Action["LoadCollectionsPerDatabase"] = 150] = "LoadCollectionsPerDatabase";
    Action[Action["RefreshNotebooksEnabled"] = 151] = "RefreshNotebooksEnabled";
    Action[Action["CheckPhoenixStatus"] = 152] = "CheckPhoenixStatus";
    Action[Action["CheckFeatureRegistration"] = 153] = "CheckFeatureRegistration";
})(Action || (Action = {}));
export const ActionModifiers = {
    Start: "start",
    Success: "success",
    Failed: "failed",
    Mark: "mark",
    Open: "open",
    IFrameReady: "iframeready",
    Close: "close",
    Submit: "submit",
    IndexAll: "index all properties",
    NoIndex: "no indexing",
    Cancel: "cancel",
    ToggleAutoscaleOn: "autoscale on",
    ToggleAutoscaleOff: "autoscale off",
};
export var SourceBlade;
(function (SourceBlade) {
    SourceBlade[SourceBlade["AddCollection"] = 0] = "AddCollection";
    SourceBlade[SourceBlade["AzureFunction"] = 1] = "AzureFunction";
    SourceBlade[SourceBlade["BrowseCollectionBlade"] = 2] = "BrowseCollectionBlade";
    SourceBlade[SourceBlade["CassandraAccountCreateBlade"] = 3] = "CassandraAccountCreateBlade";
    SourceBlade[SourceBlade["CollectionSetting"] = 4] = "CollectionSetting";
    SourceBlade[SourceBlade["DatabaseAccountCreateBlade"] = 5] = "DatabaseAccountCreateBlade";
    SourceBlade[SourceBlade["DataExplorer"] = 6] = "DataExplorer";
    SourceBlade[SourceBlade["DeleteCollection"] = 7] = "DeleteCollection";
    SourceBlade[SourceBlade["DeleteDatabase"] = 8] = "DeleteDatabase";
    SourceBlade[SourceBlade["DocumentExplorer"] = 9] = "DocumentExplorer";
    SourceBlade[SourceBlade["FirewallVNETBlade"] = 10] = "FirewallVNETBlade";
    SourceBlade[SourceBlade["Metrics"] = 11] = "Metrics";
    SourceBlade[SourceBlade["NonDocumentDBAccountCreateBlade"] = 12] = "NonDocumentDBAccountCreateBlade";
    SourceBlade[SourceBlade["OverviewBlade"] = 13] = "OverviewBlade";
    SourceBlade[SourceBlade["QueryExplorer"] = 14] = "QueryExplorer";
    SourceBlade[SourceBlade["Quickstart"] = 15] = "Quickstart";
    SourceBlade[SourceBlade["ReaderWarning"] = 16] = "ReaderWarning";
    SourceBlade[SourceBlade["ResourceMenu"] = 17] = "ResourceMenu";
    SourceBlade[SourceBlade["RpcProvider"] = 18] = "RpcProvider";
    SourceBlade[SourceBlade["ScaleCollection"] = 19] = "ScaleCollection";
    SourceBlade[SourceBlade["ScriptExplorer"] = 20] = "ScriptExplorer";
    SourceBlade[SourceBlade["Keys"] = 21] = "Keys";
})(SourceBlade || (SourceBlade = {}));
export var Source;
(function (Source) {
    Source["ResourceTreeMenu"] = "ResourceTreeMenu";
    Source["CommandBarMenu"] = "CommandBarMenu";
})(Source || (Source = {}));
